import { CheckIcon, CopyIcon, SendIcon } from "../components/icons";
import "../styles/created.css";

const HANDOFF = [
  { n: "1", label: "Send to Bank — attach documents and email the selected banks" },
  { n: "2", label: "NOA approval — record the notice of approval and its terms" },
  { n: "3", label: "Contract signing — record signing and upload the signed contract" },
  { n: "4", label: "Disbursement is tracked in the Mobile SFA app" },
];

export default function ApplicationCreatedPage({ loanId, copied, onCopy, onBackToDash, onSendToBank }) {
  return (
    <div className="done-page">
      <div className="done-col">
        <span className="done-check">
          <CheckIcon size={36} stroke="#fff" width={3} />
        </span>
        <h1 className="done-title">Application created successfully</h1>
        <button type="button" className="loan-id-chip" onClick={onCopy}>
          <span className="loan-id-chip__label">Loan ID</span>
          <span className="loan-id-chip__value">{loanId || "REM12344678"}</span>
          <span className={"loan-id-chip__icon" + (copied ? " loan-id-chip__icon--copied" : "")}>
            {copied ? <CheckIcon size={15} width={2.6} /> : <CopyIcon size={15} />}
          </span>
        </button>
        <p className="done-body">Send the application to the selected banks now, or continue later from the dashboard.</p>
        <div className="next-steps">
          <div className="next-steps__title">What happens next</div>
          <div className="next-steps__list">
            {HANDOFF.map((h) => (
              <div className="next-steps__item" key={h.n}>
                <span className="next-steps__n">{h.n}</span>
                <span className="next-steps__label">{h.label}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="done-actions">
          <button type="button" className="done-actions__back" onClick={onBackToDash}>
            Back to Dashboard
          </button>
          <button type="button" className="done-actions__send" onClick={onSendToBank}>
            <SendIcon size={17} stroke="#fff" />
            Send to Bank
          </button>
        </div>
      </div>
    </div>
  );
}
